export const inputLimits = {
  password: {
    min: 8,
    max: 32,
  },
  username: {
    min: 4,
    max: 20,
  },
  firstName: {
    min: 2,
    max: 50,
  },
  lastName: {
    min: 2,
    max: 50,
  },
  email: {
    max: 255,
  },
  referralCode: {
    min: 3,
    max: 10,
  },
  phone: {
    min: 7,
    max: 15,
  },
  otp: {
    min: 4,
    max: 6,
  },
  cardPin: {
    min: 4,
    max: 12,
  },
}
